$(document).ready(function() {
    $('.search-modal__form').submit(function() {
      if ($.trim($(".search__input").val()) === "") {
    // 		 	alert('you did not fill out one of the fields');
        return false;
      }
    });
});

document.addEventListener("DOMContentLoaded", function () {
    new Swiper(".who_we_are_sec .mySwiper", {
      slidesPerView: 1,
      spaceBetween: 0,
      effect: "fade",
      fadeEffect: {
        crossFade: true,
      },
      autoplay: {
        delay: 2500,
        disableOnInteraction: false,
      },
      speed: 800,
      loop: true,
      pagination: {
        el: ".swiper-pagination",
        clickable: true,
      },
    });

    


    new Swiper(".testimonial_slider_sec .testimonial_slider", {
      
      speed: 800,
      loop: true,
      navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
      },
      breakpoints: {
        0: {
          slidesPerView: 1,
          spaceBetween: 15,
        },
        640: {
          slidesPerView: 2,
          spaceBetween: 15,
        },
        992: {
          slidesPerView: 2.2,
          spaceBetween: 15,
        },
        1200: {
          slidesPerView: 3.15,
          spaceBetween: 25,
        },
      },
    });


document.querySelectorAll('[data-faq-btn]').forEach(btn => {
      btn.addEventListener('click', () => {
        const item = btn.closest('[data-faq]');
        const answer = item.querySelector('.faq-answer');

        if (item.classList.contains('active')) {
          item.classList.remove('active');
          answer.style.maxHeight = null;

        } else {
          document.querySelectorAll('[data-faq]').forEach(i => {
            i.classList.remove('active');
            i.querySelector('.faq-answer').style.maxHeight = null;
          });

          item.classList.add('active');
          answer.style.maxHeight = answer.scrollHeight + 'px';
        }
      });
    });


    
  });



